import * as types from '../types';

export const createPet = (values, onSuccess) => ({
  type: types.CREATE_PET_REQUEST,
  payload: {
    values,
  },
  meta: {
    onSuccess,
  },
});

export const getAllPets = onSuccess => ({
  type: types.GET_ALL_PETS_REQUEST,
  meta: {
    onSuccess,
  },
});

export const getPetData = id => ({
  type: types.GET_PET_DATA_REQUEST,
  payload: {
    id,
  },
});

export const editPetData = (id, values, onSuccess) => ({
  type: types.EDIT_PET_DATA_REQUEST,
  payload: {
    values,
    id,
  },
  meta: {
    onSuccess,
  },
});

export const deletePet = (id, onSuccess) => ({
  type: types.DELETE_PET_REQUEST,
  payload: {
    id,
  },
  meta: {
    onSuccess,
  },
});
